"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addGlobalErrorInstrumentationHandler = addGlobalErrorInstrumentationHandler;

var _worldwide = require("../worldwide.js");

var _handlers = require("./handlers.js");

let _oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */

function addGlobalErrorInstrumentationHandler(handler) {
  const type = 'error';
  (0, _handlers.addHandler)(type, handler);
  (0, _handlers.maybeInstrument)(type, instrumentError);
}

function instrumentError() {
  _oldOnErrorHandler = _worldwide.GLOBAL_OBJ.onerror; // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
  // is that we are using this handler in the Loader Script, to handle buffered errors consistently

  _worldwide.GLOBAL_OBJ.onerror = function (msg, url, line, column, error) {
    const handlerData = {
      column,
      error,
      line,
      msg,
      url
    };
    (0, _handlers.triggerHandlers)('error', handlerData);

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  _worldwide.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}